import { Component, ViewChild, ElementRef, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CustomerMessagesBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TSetting, TCampaignMessage, TCustomer } from '@shared/models';

@Component({
    'selector': 'app-campaignMessage',
    'templateUrl': './campaignMessage.page.html',
    'styleUrls': ['./campaignMessage.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class CampaignMessagePage extends CustomerMessagesBasePage implements OnInit {
    @ViewChild('rawMessage', { read: ElementRef }) public rawMessageRef: ElementRef;
    protected override elem: HTMLTextAreaElement;
    public override vm: TCampaignMessage = {
        enabled: true,
        rawMessage: '',
        renderedMessage: ''
    };

    public settings: any;   // TSetting;
    public message: any;   // TSetting;
    public submitted = false;
    public isDebugMode = false;

    constructor( injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_MARKETING_CAMPAIGN_MESSAGE);
        super.setMessageNameEvent(Constants.EVENT_CAMPAIGN_MESSAGE);
        super.setDefaultMessage(Constants.MARKETING_CAMPAIGN_MSG);
    }

    // From Ticket Created
    // public override async ngOnInit(): Promise<void> {
    //     super.ngOnInit();

    //     try {
    //         this.isDebugMode = (this.sessionService.isDebugMode());
    //         await this.uxHelperService.showSpinner();
    //         const settings = await this.settingsService.get();
    //         this.settings = settings || {};
    //         this.vm = this.settings.ticketCreated;
    //         if (!this.vm) {
    //             this.vm = {} as CustomerMessageData;
    //             this.vm.enabled = true;
    //             this.loadDefaultMessage();
    //         }
    //         // Initialize enabledStr based on enabled state
    //         this.vm.enabledStr = this.vm.enabled ? this.config.enabledLabel : this.config.disabledLabel;
    //         await this.uxHelperService.hideSpinner();
    //         this.initMoreMenu();
    //     } catch (err) {
    //         await this.uxHelperService.hideSpinner();
    //         const errorMessage = this.utilsService.extractError(err);
    //         await this.uxHelperService.showAlert('Error', errorMessage);
    //     }
    // }

    // End Ticket Created
    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            this.isDebugMode = (this.sessionService.isDebugMode());
            await this.uxHelperService.showSpinner();
            const settings = await this.settingsService.get();
            this.settings = settings || {};
            //         this.settings = settings || {};
            //         this.vm = this.settings.ticketCreated;
            //         if (!this.vm) {
            //             this.vm = {} as CustomerMessageData;
            //             this.vm.enabled = true;
            //             this.loadDefaultMessage();
            //         }



            this.vm = this.settings.campaignMessage;
            if (!this.vm) {
                this.vm = {} as TCampaignMessage;
                this.vm.enabled = true;
                this.loadDefaultMessage();
            }
            //     enabled: true,
            //     rawMessage: '',
            //     renderedMessage: '',
            // };

            // this.onEnabledChange();
            this.computeRenderedMessage();
            await this.uxHelperService.hideSpinner();
            this.initMoreMenu();
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Load Default Message');
        this.pushPopoverMenuItem('Send Message To Me');
        // this.pushPopoverMenuItem('Show Tour', 'show-campaign-message-tour');

        this.moreMenuItemClick(this.handleMenuItemClick);

        this.moreMenuItemClick((menuItem: any) => {
            switch (menuItem.name) {
                case 'Load Default Message':
                    this.loadDefaultMessage();
                    break;

                case 'Send Message To Me':
                    this.sendMessageToMe();
                    break;
            }
        });
    }

    // protected loadDefaultMessage() {
    //     this.vm.rawMessage = this.defaultMessage;
    // }

    // private async sendCampaignToMe() {
    //     try {
    //         const user = this.sessionService.getCurrentUser();
    //         if (user.role !== 'manager') {
    //             throw new Error('Only managers can send campaigns.');
    //         }

    //         const customer = this.formatUsersAsCustomers([user]);
    //         await this.sendCampaignX([customer]);
    //     } catch (err) {
    //         this.uxHelperService.showAlert('Warning', err.message);
    //     }
    // }

    // protected async sendMessageToMe() {
    //     try {
    //         if (!this.messageNameEvent) {
    //             return;
    //         }

    //         this.uxHelperService.showToast(`Sending Message Now...`);
    //         const user = this.sessionService.getCurrentUser();
    //         const customer: TCustomer = {
    //             'customerName': user.firstName + ' ' + user.lastName,
    //             'cellPhone': user.cellPhone,
    //             'isActive': true
    //         };
    //         const ts = this.dateService.now();
    //         customer.shuttleDates = [];
    //         customer.shuttleDates[0] = ts;

    //         const data = { customers: [customer], 'debug': true };
    //         await this.smsService.sendCampaignMessage(data);            
    //         this.uxHelperService.showToast(`Finished Sending Message.`);
    //         this.eventsService.publish(this.messageNameEvent, data);
    //     } catch (err) {
    //         this.uxHelperService.showAlert('Warning', err.message);
    //     }
    // }

    // private async sendCampaignX(customers: TCustomer[]) {
    //     try {
    //         this.uxHelperService.showToast(`Sending Campaign Now...`);

    //         const data = { 'customers': [customer], 'incentiveSet': this.selectedIncentiveSet };
    //         await this.smsService.sendCampaignMessage(data);            
    //         this.uxHelperService.showToast(`Finished Sending Campaign.`);

    //         const campaign: TCampaign = {
    //             sentDate: this.dateService.now(),
    //             numRecipients: this.selectedCustomers.length,
    //         };
    //         await this.campaignsService.add(campaign);
    //         this.router.navigateByUrl('/campaigns');
    //     } catch (err) {
    //         this.uxHelperService.showAlert('Error', err.message);
    //     } finally {
    //         await this.uxHelperService.hideSpinner();
    //     }
    // }

    public async onKeyUp(event): Promise<void> {
        this.elem = event.srcElement as HTMLTextAreaElement;
    }

    // public getSelectionStart(): number {
    //     return this.elem.selectionStart; 
    // }

    public async onMessageChange(): Promise<void> {
        await this.computeRenderedMessage();
        const numChars = this.vm.renderedMessage.length;
        const numParts = Math.ceil(numChars / 160);
        this.message = 'Chars: ' + numChars + '.  Parts: ' + numParts;
    }

    // public onLoadDefaultMessageClick() {
    //     this.vm.rawMessage = this.Constants.SETTINGS_CAMPAIGN_MSG;
    //     this.computeRenderedMessage();
    // }

    private async computeRenderedMessage(): Promise<void> {
        const customer: TCustomer = this.sessionService.getFakeCustomer();
        // // const rawMessage = this.settings.campaignMessage?.rawMessage    // || this.Constants.SETTINGS_CAMPAIGN_MSG;
        // const rawMessage = this.vm.rawMessage;    // || this.Constants.SETTINGS_CAMPAIGN_MSG;
        // this.vm.rawMessage = rawMessage;

        await this.variableReplacementService.reset();
        this.variableReplacementService.customer = customer;
        const renderedMessage = this.variableReplacementService.doVariableReplacements(this.vm.rawMessage);
        this.vm.renderedMessage = renderedMessage;
    }

    public async onSaveClick(form: NgForm): Promise<void> {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Saving.');

            this.settings.campaignMessage = {
                'enabled': true,
                'rawMessage': this.vm.rawMessage,
                'renderedMessage': this.vm.renderedMessage
            };

            await this.settingsService.update(this.settings);
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Saved.');
            // this.router.navigateByUrl('/marketing/nagerSettings');
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error:', errorMessage);
        }
    }
}
